import experiments from '../../common/constants/experiments'

export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  features: {
    /**
     * @description Category page
     * @author Marek Wojtaszek
     * @expires
     */
    categoryPage: false,
    'categoryPage:enrolment': true,
    'experiments:loading-cover': true
  },
  experiments_to_features: {
    [experiments.categoryPage]: {
      0: {
        categoryPage: false
      },
      1: {
        categoryPage: false
      },
      2: {
        categoryPage: true
      },
      3: {
        categoryPage: true
      }
    }
  },
  show_category_in_selected_filters: true
}
